export default "/images/vendor/flag-icon-css/flags/4x3/mt.svg?c91049a111e0a4dc2611b09a5a469c0b";